<style lang="less" scoped>
.main-container {
  height: 100%;
  min-height: 100%;
}
</style>

<template lang="pug">
  .main-container
    intro
</template>

<script>
import Intro from "@/components/Intro.vue";

export default {
  components: {
    Intro
  }
};
</script>
